"use client";

import React from "react";
const exchanges = [{
  name: "Bitcoin",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634070/img/asset_btc.png"
}, {
  name: "Ethereum",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634070/img/asset_eth.png"
}, {
  name: "Solana",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634070/img/asset_sol.png"
}, {
  name: "Monero",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634070/img/asset_xmr.png"
}, {
  name: "Tether",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634070/img/asset_usdt.png"
}, {
  name: "Bitcoin",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634070/img/asset_btc.png"
}, {
  name: "Ethereum",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634070/img/asset_eth.png"
}, {
  name: "Solana",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634070/img/asset_sol.png"
}, {
  name: "Monero",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634070/img/asset_xmr.png"
}, {
  name: "Tether",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634070/img/asset_usdt.png"
}, {
  name: "Bitcoin",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634070/img/asset_btc.png"
}, {
  name: "Ethereum",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634070/img/asset_eth.png"
}];
export default function SupportedExchanges() {
  const duplicatedExchanges = [...exchanges, ...exchanges];
  return <section data-section-id="134113" id="encryption-asset-support" className="dark bg-background py-16 md:py-20 overflow-hidden border-y border-border">
      <div className="container mx-auto px-4 md:px-6">
        <h2 className="text-center text-xs md:text-sm font-default font-bold tracking-widest uppercase text-muted-foreground mb-10 md:mb-12">
          AES-256 Encrypted Delivery • Asset Support
        </h2>

        {}
        <div className="relative flex overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_10%,black_90%,transparent)]">
          
          {}
          <div className="flex w-max animate-[marquee_40s_linear_infinite] hover:[animation-play-state:paused]">
            {duplicatedExchanges.map((exchange, i) => <div key={i} data-index={i} className="flex items-center justify-center w-[140px] md:w-[200px] px-4 md:px-8 shrink-0">
                <img src={exchange.logo} alt={`${exchange.name} logo`} className="h-8 md:h-10 w-auto object-contain grayscale opacity-40 hover:grayscale-0 hover:opacity-100 transition-all duration-300 cursor-pointer" loading="lazy" />
              </div>)}
          </div>

        </div>
      </div>

      {}
      <style>
        {`
          @keyframes marquee {
            0% { transform: translateX(0%); }
            100% { transform: translateX(-50%); }
          }
        `}
      </style>
    </section>;
}